"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _revisions = require("composer-lib/redux/actions/revisions");

var _Revisions = require("composer-lib/redux/reducers/Revisions");

var _uiSettings = require("composer-lib/redux/actions/uiSettings");

var _editor = require("composer-lib/redux/actions/editor");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _RevisionsModal = _interopRequireDefault(require("composer-lib/components/modals/revisions/RevisionsModal"));

var _Revisions2 = _interopRequireDefault(require("composer-lib/data/model/Revisions"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _immutable = require("immutable");

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _UserAttributes = _interopRequireDefault(require("composer-lib/data/model/UserAttributes"));

function getSelectedRevisionObject(revisions, selectedRevision) {
  if (!selectedRevision) {
    return null;
  }

  return revisions.objects.find(function (_ref) {
    var id = _ref.id;
    return id === selectedRevision;
  });
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    lock: state.lock,
    revisions: (0, _Revisions.getRelevantRevisions)(state),
    saveState: state.save,
    uiSettings: state.uiSettings,
    userAttributes: state.userAttributes
  };
};

var mapDispatchToProps = {
  fetchRevisions: _revisions.fetchRevisions,
  hideRevisions: _uiSettings.hideRevisions,
  insertableLoaded: _editor.insertableLoaded,
  revertToRevision: _revisions.revertToRevision
};
var RevisionsContainer = (0, _createReactClass.default)({
  displayName: "RevisionsContainer",
  propTypes: {
    auth: _propTypes.default.object,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    fetchRevisions: _propTypes.default.func.isRequired,
    hideRevisions: _propTypes.default.func.isRequired,
    insertableLoaded: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    revertToRevision: _propTypes.default.func.isRequired,
    revisions: _propTypes.default.instanceOf(_Revisions2.default).isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    userAttributes: _propTypes.default.instanceOf(_UserAttributes.default).isRequired
  },
  contextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  getInitialState: function getInitialState() {
    return {
      selectedRevision: null
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var selectedRevision = this.state.selectedRevision;
    var auth = nextProps.auth,
        composition = nextProps.composition,
        revisions = nextProps.revisions,
        uiSettings = nextProps.uiSettings;
    var revisionObjects = revisions.objects;

    if (!this.props.uiSettings.showRevisions && uiSettings.showRevisions) {
      this.props.fetchRevisions(composition.id, auth.session);
    } else if (revisionObjects.size === 0) {
      if (this.props.composition.status === _constants.RequestStatus.PENDING && composition.status === _constants.RequestStatus.SUCCEEDED) {
        this.props.fetchRevisions(composition.id, auth.session);
      }
    } else if (!selectedRevision) {
      this.selectRevision(revisionObjects.first().id);
    }
  },
  UNSAFE_componentWillUpdate: function UNSAFE_componentWillUpdate(nextProps, nextState) {
    var revisions = nextProps.revisions;
    var selectedRevision = nextState.selectedRevision;
    var revisionObjects = revisions.objects;

    if (revisionObjects.size > 0 && !getSelectedRevisionObject(revisions, selectedRevision)) {
      this.selectRevision(revisionObjects.first().id);
    }
  },
  getAuth: function getAuth() {
    return this.props.auth;
  },
  getCommentsOnly: function getCommentsOnly() {
    var _this$props = this.props,
        auth = _this$props.auth,
        lock = _this$props.lock,
        saveState = _this$props.saveState;
    return (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
  },
  getEditorState: function getEditorState() {
    return this.props.saveState.content;
  },
  getIsCollectBeta: function getIsCollectBeta() {
    return !!this.context.gates.get('cos_blog_collect_beta');
  },
  getReadOnly: function getReadOnly() {
    return true;
  },
  getUserAttributes: function getUserAttributes() {
    return this.props.userAttributes;
  },
  getEditorProps: function getEditorProps() {
    return {
      getAuth: this.getAuth,
      getCommentsOnly: this.getCommentsOnly,
      getEditorState: this.getEditorState,
      getIsCollectBeta: this.getIsCollectBeta,
      getReadOnly: this.getReadOnly,
      getUserAttributes: this.getUserAttributes,
      onInsertableLoaded: this.props.insertableLoaded
    };
  },
  fetchNextRevisions: function fetchNextRevisions() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        composition = _this$props2.composition,
        revisions = _this$props2.revisions;
    var newOffset = revisions.get('lastFetchOffset') + 25;
    this.props.fetchRevisions(composition.id, auth.session, newOffset);
  },
  handleRevert: function handleRevert() {
    var _this$props3 = this.props,
        auth = _this$props3.auth,
        composition = _this$props3.composition;
    this.props.revertToRevision(composition.id, this.state.selectedRevision, auth.session);
  },
  selectRevision: function selectRevision(id) {
    this.setState({
      selectedRevision: id
    });
  },
  render: function render() {
    var _this$props4 = this.props,
        composerSettings = _this$props4.composerSettings,
        revisions = _this$props4.revisions,
        uiSettings = _this$props4.uiSettings;
    var selectedRevision = this.state.selectedRevision;
    return _react.default.createElement(_RevisionsModal.default, {
      composerSettings: composerSettings,
      fetchNextRevisions: this.fetchNextRevisions,
      getEditorProps: this.getEditorProps,
      hideRevisions: this.props.hideRevisions,
      onRevertClick: this.handleRevert,
      revisions: revisions,
      selectedRevision: selectedRevision,
      selectedRevisionObject: getSelectedRevisionObject(revisions, selectedRevision),
      selectRevision: this.selectRevision,
      uiSettings: uiSettings
    });
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RevisionsContainer);

exports.default = _default;
module.exports = exports.default;